import { BCMSRecord, useGlobalController, useParams, Workflow } from "@bcm-dev/bcms-vite";
import { Biller } from "model";
import BillDiscoveryItem from "./classes/BillDiscoveryItem";

import FindMyBillsPage from "compid/pages/FindMyBillsPage";
import SearchResultsPage from "compid/pages/SearchResultsPage";

const steps = {
    "/FindMyBills" : <FindMyBillsPage />,
    "/SearchResults" : <SearchResultsPage />
};

export default function BillDiscoveryWorkflow(props) {
    const controller = useGlobalController();
    const value = getDefaultDiscovery(controller);

    const { stepID } = useParams();
    return <Workflow value={ value } step={ stepID } steps={ Object.values(steps) } />
}

export const getWorkflowSteps = () => steps;

export const getDefaultDiscovery = controller => {
    BCMSRecord.globalControllerFor([ Biller ], controller);

    const billers = Biller.initAll();
    const getBillers = type => billers.filter(item => item.addType === type, []).map(item => BillDiscoveryItem.init(item), []);

    return {
        quickAdd: getBillers("quick_add"),
        verificationAdd: getBillers("verification_add"),

        addedItems: []
    };
};